export default (that) => [
  {
    text: that.$l('menu_text_detailDict') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
    allow: '',
    status: [],
    divided: false,
  },
  {
    text: that.$l('menu_text_editDict') || '编辑字典',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'M',
    status: ['N'],
    divided: true,
  },
  {
    text: that.$l('menu_text_deleteDict') || '删除字典',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    status: ['N'],
    divided: false,
  },
  {
    text: that.$l('menu_text_copyDict') || '复制字典',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'P',
    status: [],
    divided: true,
  },
  {
    text: that.$l('menu_text_reviewDict') || '审核字典',
    icon: 'el-icon-view',
    menuType: 'review',
    allow: 'C',
    status: ['N'],
    divided: true,
  },
  {
    text: that.$l('menu_text_review_edit') || '审核修改',
    icon: 'el-icon-edit-outline',
    menuType: 'reviewEdit',
    allow: 'Z',
    status: ['Y'],
    divided: false,
  },
  {
    text: that.$l('menu_text_deactivateDict') || '停用字典',
    icon: 'el-icon-circle-close',
    menuType: 'deactivate',
    allow: 'S',
    status: ['Y'],
    divided: true,
  },
  {
    text: that.$l('menu_text_enableDict') || '启用字典',
    icon: 'el-icon-circle-check',
    menuType: 'enable',
    allow: 'E',
    status: ['S'],
    divided: false,
  },
]
